class BlogSearchInput extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        .blog-input-wrapper {
            position: relative;
            width: 100%;
        }
        .blog-input-wrapper label {
            position: absolute;
            left: 20px;
            top: 14px;
            color: #C4C4C4;
            font-size: 16px;
            font-weight: 400;
            line-height: normal;
            pointer-events: none;
        }
        .blog-input-wrapper label svg {
            width: 17px;
            height: 17px;
            vertical-align: bottom;
            margin-right: 8px;
            color: #999;
        }
        .blog-input-wrapper input {
            width: 100%;
            height: 48px;
            border-radius: 4px;
            background: #FFF;
            padding: 14px 20px 14px 24px;
            border: 1px solid #D5D5D5;
            box-sizing: border-box;
        }
        .blog-input-wrapper input:focus,
        .blog-input-wrapper input:focus-visible,
        .blog-input-wrapper input:active {
            outline: none;
            box-shadow: none;
            border-radius: 4px 4px 0 0;
        }
        .blog-input-wrapper input:focus + label,
        .blog-input-wrapper input:not(:placeholder-shown) + label {
            display: none;
        }
        .blog-search-results {
            display: none;
            position: absolute;
            top: 48px;
            left: 0;
            width: 100%;
            max-height: 300px;
            overflow-y: auto;
            background: #FFF;
            border: 1px solid #D5D5D5;
            border-top: none;
            border-radius: 0 0 4px 4px;
            box-sizing: border-box;
            z-index: 10;
        }
        .blog-search-results.active {
          display: block;
        }
        .blog-search-results ul {
            list-style: none;
            margin: 0;
            padding: 8px 0;
        }
        .blog-search-results ul li {
            padding: 8px 16px;
            border-bottom: 1px solid #F0F0F0;
        }
        .blog-search-results ul li:last-child {
            border-bottom: none;
        }
        .blog-search-results a {
          text-decoration: none;
          color: #000;
          font-size: 14px;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 40px;
        }
        .blog-search-results ul li a:hover {
            text-decoration: underline;
        }
        .blog-search-results li + li {
          border-top: 1px solid #eee;
        }
        .blog-search-results .card__inner {
            display: flex;
        }
        .blog-search-results .article-card__image-wrapper {
          position: relative;
          width: 50%;
        }
        .blog-search-results .article-card__image.media {
            position: absolute;
            width: 100%;
            padding-top: 75%;
        }
        .blog-search-results .article-card__image.media img {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          object-fit: cover;
        }
        .blog-search-results .article-card > .card__content {
            display: none;
        }
        .blog-search-results .card__content {
          width: 50%;
          padding: 8px 12px;
          box-sizing: border-box;
        }
        .blog-search-results .card__content h3 {
          margin: 0 0 8px 0;
        }
        .blog-search-results .card__badge {
          display: none;
        }
        .blog-search-results.loading::after {
          content: 'Loading...';
          display: block;
          padding: 16px;
          text-align: center;
          color: #666;
          font-size: 14px;
        }
        .blog-search-results .no-results {
          padding: 16px;
          text-align: center;
          color: #666;
          font-size: 14px;
        }
      </style>
      <div class="blog-input-wrapper">
            <input type="text" class="blog-search-input" placeholder=" ">
            <label for="blog-search-input" class="blog-search-icon">
                <svg fill="none" class="icon icon-search" viewBox="0 0 18 19"><path fill="currentColor" fill-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z" clip-rule="evenodd"/></svg>
                <span>Search ideas + advice articles</span>
            </label>
            <div class="blog-search-results"></div>
      </div>
    `;
  }

  searchBlog(keyword) {
    this.shadowRoot.querySelector('.blog-search-results').classList.add('loading');
    fetch(`/search?type=article&q=${encodeURIComponent(keyword)}`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const mainContent = doc.querySelector('#MainContent');
      const resultsWrapper = mainContent.querySelector('.template-search');
      const results = resultsWrapper.querySelector('ul');

      if (resultsWrapper.classList.contains('template-search--empty')) {
        results.innerHTML = '<p class="no-results">No results found</p>';
      }

      this.shadowRoot.querySelector('.blog-search-results').innerHTML = results ? results.innerHTML : '<p class="no-results">No results found</p>';

    })
    .finally(() => {
      this.shadowRoot.querySelector('.blog-search-results').classList.remove('loading');
    });
  }

  clickOutside(event) {
    if (!this.contains(event.target)) {
      this.shadowRoot.querySelector('.blog-search-results').classList.remove('active');
    }
  }

  disconnectedCallback() {
    const input = this.shadowRoot.querySelector('input');
    input.removeEventListener('keyup', this.handleKeyUp);
  }

  connectedCallback() {
    const input = this.shadowRoot.querySelector('input');

    document.addEventListener('click', this.clickOutside.bind(this));

    input.addEventListener('keyup', (event) => {
      const keyword = input.value.trim();
      if (keyword) {
        this.searchBlog(keyword);
        this.shadowRoot.querySelector('.blog-search-results').classList.add('active');
      }
    });
  }
}

customElements.define('blog-search-input', BlogSearchInput);